import script from "./ReservationService.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationService.vue?vue&type=script&setup=true&lang=js"

import "./ReservationService.vue?vue&type=style&index=0&id=6fc28c4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc28c4e"]])

export default __exports__